import Utility from "./utility";
import JsPdf from "jspdf";
import JsZip from "jszip";
import FileSaver from "file-saver";

export const Lang = {
  viewFullscreen: "全屏",
  contextButtonTitle: "图表导出菜单",
  decimalPoint: ".",
  downloadJPEG: "下载JPEG图片",
  downloadPDF: "下载PDF文件",
  downloadPNG: "下载PNG文件",
  downloadSVG: "下载SVG文件",
  drillUpText: "返回 {series.name}",
  loading: "加载中",
  months: [
    "一月",
    "二月",
    "三月",
    "四月",
    "五月",
    "六月",
    "七月",
    "八月",
    "九月",
    "十月",
    "十一月",
    "十二月",
  ],
  noData: "暂无数据",
  numericSymbols: ["K", "M", "G", "T", "P", "E"],
  printChart: "打印图表",
  resetZoom: "恢复缩放",
  resetZoomTitle: "恢复图表",
  shortMonths: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
  thousandsSep: ",",
  weekdays: [
    "星期一",
    "星期二",
    "星期三",
    "星期四",
    "星期五",
    "星期六",
    "星期天",
  ],
};
export const Colors = [
  "#824880",
  "#006e54",
  "#e6b422",
  "#96514d",
  "#bf242a",
  "#17184b",
  "#6e7955",
  "#1f3134",
  "#2c4f54",
  "#c8c2c6",
  "#333631",
  "#cd8c5c",
  "#715c1f",
  "#4f455c",
  "#eb6ea5",
  "#513743",
  "#d4dcd6",
  "#84a2d4",
  "#c3d825",
  "#ffea00",
];

export const DefaultChartOptions = {
  lang: Lang,
  colors: Colors,
};

export const Alpha = {
  100: "FF",
  99: "FC",
  98: "FA",
  97: "F7",
  96: "F5",
  95: "F2",
  94: "F0",
  93: "ED",
  92: "EB",
  91: "E8",
  90: "E6",
  89: "E3",
  88: "E0",
  87: "DE",
  86: "DB",
  85: "D9",
  84: "D6",
  83: "D4",
  82: "D1",
  81: "CF",
  80: "CC",
  79: "C9",
  78: "C7",
  77: "C4",
  76: "C2",
  75: "BF",
  74: "BD",
  73: "BA",
  72: "B8",
  71: "B5",
  70: "B3",
  69: "B0",
  68: "AD",
  67: "AB",
  66: "A8",
  65: "A6",
  64: "A3",
  63: "A1",
  62: "9E",
  61: "9C",
  60: "99",
  59: "96",
  58: "94",
  57: "91",
  56: "8F",
  55: "8C",
  54: "8A",
  53: "87",
  52: "85",
  51: "82",
  50: "80",
  49: "7D",
  48: "7A",
  47: "78",
  46: "75",
  45: "73",
  44: "70",
  43: "6E",
  42: "6B",
  41: "69",
  40: "66",
  39: "63",
  38: "61",
  37: "5E",
  36: "5C",
  35: "59",
  34: "57",
  33: "54",
  32: "52",
  31: "4F",
  30: "4D",
  29: "4A",
  28: "47",
  27: "45",
  26: "42",
  25: "40",
  24: "3D",
  23: "3B",
  22: "38",
  21: "36",
  20: "33",
  19: "30",
  18: "2E",
  17: "2B",
  16: "29",
  15: "26",
  14: "24",
  13: "21",
  12: "1F",
  11: "1C",
  10: "1A",
  9: "17",
  8: "14",
  7: "12",
  6: "0F",
  5: "0D",
  4: "0A",
  3: "08",
  2: "05",
  1: "03",
  0: "00",
};

export function paramConvert(code, value) {
  if (code === "pctFlag_pie") {
    // 饼图百分比
    if (value) return "{point.name}: {point.y}<br/>{point.percentage:.1f}%";
    return "{point.name}: {point.y}";
  }
  if (code === "colors") return JSON.stringify(value.split(","));
  if (code === "venn_colors") {
    let rgbs = [],
      hexs = value.split(",");
    hexs.forEach((hex) => rgbs.push(Utility.colorRGB(hex)));
    return JSON.stringify(rgbs);
  }
  if (code === "displayStat") return value != false; // venn图显示统计
  if (code === "venn_fontSize") return value + "px";
  if (code === "volcano_control") return Math.log2(value);
  if (code === "volcano_pvalue") return -Math.log10(value);
  if (code === "legendAlign") {
    // 图例位置
    if (value == "tc")
      return {
        legend: { align: "center", layout: "horizontal", verticalAlign: "top" },
      };
    else if (value == "bc")
      return {
        legend: {
          align: "center",
          layout: "horizontal",
          verticalAlign: "bottom",
        },
      };
    else if (value == "lc")
      return {
        legend: { align: "left", layout: "vertical", verticalAlign: "middle" },
      };
    else if (value == "rc")
      return {
        legend: { align: "right", layout: "vertical", verticalAlign: "middle" },
      };
  }
  if (code === "regionColors") {
    // 区间颜色
    let colors = value.split(","),
      stops = [];
    for (let i = 0, l = colors.length; i < l; i++)
      stops.push([i * 0.5, colors[i]]);
    return { colorAxis: { stops: stops } };
  }
  if (code === "minMaxColors") {
    // 双色(最小值,最大值)
    let colors = value.split(",");
    return { colorAxis: { minColor: colors[0], maxColor: colors[1] } };
  }
  return value === undefined ? "" : value;
}

// 输出svg为 png、jpeg、svg、pdf
export function exportSVG(svgNode, option) {
  svgNode.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
  // let svgUrl = window.URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(svgNode)], { type: "image/svg+xml;charset=utf-8," }));
  // let svgUrl = 'data:image/svg+xml;base64,' + window.btoa(svgNode);
  // let svgUrl = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svgNode.outerHTML.replace(/></g, '>\n\r<'));
  // let svgUrl = `data:image/svg+xml;base64,${window.btoa(unescape(encodeURIComponent(svgNode.outerHTML)))}`;

  // let svgUrl;
  // if (option.venn) svgUrl = `data:image/svg+xml;base64,${window.btoa(unescape(encodeURIComponent(svgNode.outerHTML)))}`;
  // else svgUrl = window.URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(svgNode)], { type: "image/svg+xml;charset=utf-8," }));
  let svgUrl = `data:image/svg+xml;base64,${window.btoa(
    unescape(encodeURIComponent(svgNode.outerHTML))
  )}`;
  if (option.type == "image/svg-xml") {
    // svg
    let a = document.createElement("a");
    a.href = svgUrl;
    a.download = `${option.filename || "result"}.svg`;
    a.click();
  } else if (option.type == "application/pdf") {
    // pdf
    let w = option.width,
      h = option.height;
    let canvas = document.createElement("canvas");
    let ctx = canvas.getContext("2d");
    canvas.width = w;
    canvas.height = h;
    let img = new Image();
    img.src = svgUrl;
    img.onload = function () {
      ctx.drawImage(img, 0, 0, w, h);
      let pdf = getPdf(canvas, ctx, option.dpi);
      pdf.save(`${option.filename || "result"}.pdf`);
    };
  } else {
    let w = option.width,
      h = option.height;
    let canvas = document.createElement("canvas");
    let ctx = canvas.getContext("2d");
    canvas.width = w;
    canvas.height = h;
    let img = new Image();
    img.src = svgUrl;
    img.onload = function () {
      ctx.drawImage(img, 0, 0, w, h);
      let suffix = "png";
      if (option.type == "image/jpeg") suffix = "jpeg";
      else if (option.type == "image/tiff") suffix = "tiff";
      let url = canvas.toDataURL(option.type);
      let a = document.createElement("a");
      a.href = url;
      a.download = `${option.filename || "result"}.${suffix}`;
      a.click();
    };
  }
}

// 根据svg获取图片的base64
export async function getImgData(svgNode, w, h) {
  // let svgUrl = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svgNode.outerHTML.replace(/></g, '>\n\r<'));
  // let svgUrl = window.URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(svgNode)], { type: "image/svg+xml;charset=utf-8," }));
  let svgUrl = `data:image/svg+xml;base64,${window.btoa(
    unescape(encodeURIComponent(svgNode.outerHTML))
  )}`;
  let canvas = document.createElement("canvas");
  let ctx = canvas.getContext("2d");
  canvas.width = w;
  canvas.height = h;
  let img = new Image();
  img.src = svgUrl;
  return await new Promise((resolve) => {
    img.onload = function () {
      ctx.drawImage(img, 0, 0, w, h);
      let url = canvas.toDataURL("image/png");
      resolve(url);
    };
  });
}

export async function getPdfData(svgNode, w, h, dpi = 150) {
  // svgNode.setAttribute("fillColor", "#FFFFFF");
  // let svgUrl = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svgNode.outerHTML.replace(/></g, '>\n\r<'));
  // let svgUrl = window.URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(svgNode)], { type: "image/svg+xml;charset=utf-8," }));
  let svgUrl = `data:image/svg+xml;base64,${window.btoa(
    unescape(encodeURIComponent(svgNode.outerHTML))
  )}`;
  let canvas = document.createElement("canvas");
  let ctx = canvas.getContext("2d");
  canvas.width = w;
  canvas.height = h;
  let img = new Image();
  img.src = svgUrl;
  return await new Promise((resolve) => {
    img.onload = function () {
      ctx.drawImage(img, 0, 0, w, h);
      let pdf = getPdf(canvas, ctx, dpi);
      resolve(pdf.output("blob"));
    };
  });
}

// 输出svg为zip压缩包
export function exoprtCharts(svgNodes, option, fileNames) {
  if (option.type == "image/svg-xml") {
    // svg
    let zip = new JsZip();
    for (let i = 0; i < svgNodes.length; i++) {
      let svgNode = svgNodes[i];
      var data = new Blob([svgNode.outerHTML], {
        type: "image/svg+xml;charset=utf-8",
      });
      let fileName = (fileNames && fileNames[i] ? fileNames[i] : i++) + ".svg";
      zip.file(fileName, data, { binary: true });
    }
    zip.generateAsync({ type: "blob" }).then((content) => {
      FileSaver.saveAs(content, `${option.filename || "result"}.zip`);
    });
  } else if (option.type == "application/pdf") {
    // pdf
    let zip = new JsZip();
    let pms = [];
    for (let i = 0; i < svgNodes.length; i++) {
      let fileName = (fileNames && fileNames[i] ? fileNames[i] : i++) + ".pdf";
      let svgNode = svgNodes[i];
      pms[i] = new Promise((resolve) => {
        // let svgUrl = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svgNode.outerHTML.replace(/></g, '>\n\r<'));
        // let svgUrl = window.URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(svgNode)], { type: "image/svg+xml;charset=utf-8," }));
        let svgUrl = `data:image/svg+xml;base64,${window.btoa(
          unescape(encodeURIComponent(svgNode.outerHTML))
        )}`;
        let w = option.width,
          h = option.height;
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        canvas.width = w;
        canvas.height = h;
        let img = new Image();
        img.src = svgUrl;
        img.onload = function () {
          ctx.drawImage(img, 0, 0, w, h);
          let pdf = getPdf(canvas, ctx, option.dpi);
          let data = pdf.output("blob");
          zip.file(fileName, data, { binary: true });
          resolve();
        };
      });
    }
    Promise.all(pms).then(() => {
      zip.generateAsync({ type: "blob" }).then((content) => {
        FileSaver.saveAs(content, `${option.filename || "result"}.zip`);
      });
    });
  } else {
    let zip = new JsZip();
    let pms = [];
    for (let i = 0; i < svgNodes.length; i++) {
      let svgNode = svgNodes[i];
      pms[i] = new Promise((resolve) => {
        // let svgUrl = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svgNode.outerHTML.replace(/></g, '>\n\r<'));
        // let svgUrl = window.URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(svgNode)], { type: "image/svg+xml;charset=utf-8," }));
        let svgUrl = `data:image/svg+xml;base64,${window.btoa(
          unescape(encodeURIComponent(svgNode.outerHTML))
        )}`;
        let w = option.width,
          h = option.height;
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        canvas.width = w;
        canvas.height = h;
        let img = new Image();
        img.src = svgUrl;
        img.onload = function () {
          ctx.drawImage(img, 0, 0, w, h);
          let suffix = "png";
          if (option.type == "image/jpeg") suffix = "jpeg";
          else if (option.type == "image/tiff") suffix = "tiff";
          let url = canvas.toDataURL(option.type);
          let data = url.replace(/^data:image\/(png|tiff|jpeg);base64,/, "");
          let fileName =
            (fileNames && fileNames[i] ? fileNames[i] : i++) + "." + suffix;
          zip.file(fileName, data, { base64: true });
          resolve();
        };
      });
    }
    Promise.all(pms).then(() => {
      zip.generateAsync({ type: "blob" }).then((content) => {
        FileSaver.saveAs(content, `${option.filename || "result"}.zip`);
      });
    });
  }
}

function getPdf(canvas, ctx, dpi = 150) {
  // let a4w, a4h, space = 10;
  // if (dpi == 72) { a4w = 595; a4h = 842; }
  // else if (dpi == 150) { a4w = 1240; a4h = 1754; space = space * dpi / 72; }
  // else if (dpi == 300) { a4w = 2480; a4h = 3508; space = space * dpi / 72; }
  // let pdf;
  // let cw = canvas.width, ch = canvas.height;
  // if (ch > a4h) { // 如果图像的高度超过1200,则表示有多页(这里不好计算高度,只能指定一个固定值)
  //   pdf = new JsPdf('p', 'px', [a4w, a4h], true);
  //   let ph = 0;
  //   while (ph < ch) {
  //     var pcv = document.createElement('canvas');
  //     pcv.width = cw;
  //     pcv.height = Math.min(a4h, ch - ph);
  //     // 用getImageData剪裁指定区域，并画到前面创建的canvas对象中
  //     let pageImg = ctx.getImageData(0, ph, cw, pcv.height);
  //     pcv.getContext('2d').putImageData(pageImg, 0, 0);
  //     if (ph == 0) { // 第一页顶边距
  //       pdf.addImage(pcv.toDataURL('image/png'), 'png', space, space, cw - space * 2, pcv.height - space)
  //     } else {
  //       pdf.addImage(pcv.toDataURL('image/png'), 'png', space, 0, cw - space * 2, pcv.height)
  //     }
  //     ph += pcv.height;
  //     if (ph < ch) pdf.addPage()
  //   }
  // } else { // 单页
  //   pdf = new JsPdf('l', 'px', [cw + space * 2, ch + space * 2], true);
  //   pdf.addImage(canvas.toDataURL('image/png'), 'png', space, space, cw, ch);
  // }

  console.log(dpi);
  let pdf = new JsPdf("p", "mm", "a4"); // A4纸，纵向
  let a4w = 170;
  var a4h = 257; // A4大小，210mm x 297mm，四边各保留20mm的边距，显示区域170x257
  let imgHeight = Math.floor((a4h * canvas.width) / a4w); // 按A4显示比例换算一页图像的像素高度
  let renderedHeight = 0;
  while (renderedHeight < canvas.height) {
    let page = document.createElement("canvas");
    page.width = canvas.width;
    page.height = Math.min(imgHeight, canvas.height - renderedHeight); // 可能内容不足一页
    // 用getImageData剪裁指定区域，并画到前面创建的canvas对象中
    page
      .getContext("2d")
      .putImageData(
        ctx.getImageData(
          0,
          renderedHeight,
          canvas.width,
          Math.min(imgHeight, canvas.height - renderedHeight)
        ),
        0,
        0
      );
    pdf.addImage(
      page.toDataURL("image/png", 1.0),
      "PNG",
      10,
      10,
      a4w,
      Math.min(a4h, (a4w * page.height) / page.width)
    ); // 添加图像到页面，保留10mm边距
    renderedHeight += imgHeight;
    if (renderedHeight < canvas.height) {
      pdf.addPage();
    } // 如果后面还有内容，添加一个空页
  }
  return pdf;
}

// export function

// hcharts 导出
// export function exportChart (chart, option) {
//   if (option.type == 'image/svg-xml') {
//     let svg = chart.getSVG();
//     let url = window.URL.createObjectURL(new Blob([svg]), { type: option.type });
//     let a = document.createElement('a');
//     a.href = url;
//     a.download = `${option.filename || 'result'}.svg`;
//     a.click();
//   } else chart.exportChartLocal(option);
// }

// // eslint-disable-next-line no-unused-vars
// let express = 'a.b.c', evalue = 1;
// let parts = express.split('.');
// let ret = {}, preParts = '';
// for (let i = 0, l = parts.length; i < l; i++) {
//   preParts += `.${parts[i]}`;
//   if (i == l - 1) {
//     eval(`ret${preParts}=evalue`)
//   } else {
//     eval(`ret${preParts}={}`)
//   }
// }
// // eslint-disable-next-line no-console
// console.log(ret);

// // eslint-disable-next-line no-unused-vars
// let bb = 'a.b[0][1].c=2', bb2 = {};
// // eslint-disable-next-line no-constant-condition
// let i = 0;
// while (i < 10) {
//   try {
//     eval(`bb2.${bb}`);
//     break;
//   } catch (ex) {
//     console.log(String(ex));
//     // TypeError: bb2.a is undefined    TypeError: bb2.a.b[0] is undefined
//     let vv = String(ex).replace('TypeError: ', '').replace(' is undefined', '');
//     let idx = vv.indexOf('[');
//     if (idx == -1) eval(`${vv}={}`);
//     else {
//       let b1 = vv.substring(0, idx);
//       let b2 = vv.substring(idx + 1, vv.indexOf(']'));
//       console.log(b1, b2);
//       eval(`${b1}=[{}]`);
//     }
//   }
//   i++;
// }
// console.log(bb2);

export const asg = {
  // 订单状态值转化  1：送样中。2：执行中。3：检测已完成，代付款。4：报告待确认。5：报告已确认。6：报告可下载。7：已结项。
  status: [
    {
      value: "-1",
      name: "全部",
    },
    {
      value: "1",
      name: "送样中",
    },
    {
      value: "2",
      name: "执行中",
    },
    {
      value: "3",
      name: "检测已完成，待付款",
    },
    {
      value: "4",
      name: "报告待确认",
    },
    {
      value: "5",
      name: "报告已确认",
    },
    {
      value: "6",
      name: "报告可下载",
    },
    {
      value: "7",
      name: "已结项",
    }
  ],
  // 订单对应字典值
  statusDict: {
    sample: "1", //送样中
    execute: "2", //执行中
    test: "3", //检测已完成，代付款
    waitConfirm: "4", //报告待确认
    confirmed: "5", //报告已确认
    download: "6", //报告可下载
    end: "7", //已结项
  },
  // 余样状态值 0：待处理。1：回收中。2：回收完成。3：销毁完成。4：到期销毁。5：销毁中。
  sampleStatus: [
    {
      value: "-1",
      name: "全部",
    },
    {
      value: "0",
      name: "待处理",
    },
    {
      value: "1",
      name: "回收中",
    },
    {
      value: "2",
      name: "回收完成",
    },
    {
      value: "5",
      name: "销毁中",
    },
    {
      value: "3",
      name: "销毁完成",
    },
    {
      value: "4",
      name: "到期自动销毁",
    },
    {
      value: "6",
      name: "样品已用完",
    },
  ],
  // 余样对应字典值
  sampleDict: {
    wait: "0", //待处理
    recovering: "1", //回收中
    recovered: "2", //回收完成
    destroyed: "3", //销毁完成
    destroy: "4", //到期销毁
    destroying: "5", //销毁中
  },
  // 对应BP项目状态；0：未生效。1：生效。2：送样。5：冻结。6：终止。7：检测完成。8：完成。9：作废。10：报告确认。
  projectStatus: [
    {
      value: "-1",
      name: "全部",
    },
    {
      value: "0",
      name: "未生效",
    },
    {
      value: "1",
      name: "生效",
    },
    {
      value: "2",
      name: "送样",
    },
    {
      value: "5",
      name: "冻结",
    },
    {
      value: "6",
      name: "终止",
    },
    {
      value: "7",
      name: "检测完成",
    },
    {
      value: "8",
      name: "完成",
    },
    {
      value: "9",
      name: "作废",
    },
    {
      value: "10",
      name: "报告确认",
    },
  ]


};
